import { render } from "./CouponAdd.vue?vue&type=template&id=19f425ae"
import script from "./CouponAdd.vue?vue&type=script&lang=js"
export * from "./CouponAdd.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/intermagtech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__